export default __webpack_public_path__ + "static/AGaramondPro-Semibold-5edf94f8925c617a1d44c40edbd15b70.ttf";